<template>
  <div>
    <el-dialog
      :title="idx == null ? 'Add Refund Item' : 'Edit Refund Item'"
      :close-on-click-modal="false"
      :visible.sync="visible"
      width="1000px"
      top="3vh"
    >
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" autocomplete="off" label-position="top">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Refund Order" prop="orderId">
              <el-select
                v-model="dataForm.orderId"
                clearable
                filterable
                :disabled="idx != null"
                placeholder="Select refund order"
                class="wdb100"
                @change="orderIdChange"
              >
                <el-option
                  v-for="item in paidOrderInfoList"
                  :key="`orderId-${item.id}`"
                  :label="item.description"
                  :value="item.id"
                  :disabled="usedOrderIdList.includes(item.id)"
                  :title="usedOrderIdList.includes(item.id) ? 'Already in use' : ''"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Invoice Template" prop="invoiceTemplateId">
              <el-select v-model="dataForm.invoiceTemplateId" clearable filterable class="wdb100" @change="invoiceTemplateChange">
                <el-option v-for="item in invoiceTemplateList" :key="`invoiceTemplate-${item.id}`" :label="item.templateName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Gov Fee" prop="deductionAcraFee">
              <el-input v-model="dataForm.deductionAcraFee" clearable placeholder="Gov Fee" v-positivePoint>
                <template slot="prefix">{{ currencySymbolFormat(billingCurrency) }}</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Handling Fee" prop="deductionHandlingFee">
              <el-input v-model="dataForm.deductionHandlingFee" clearable placeholder="Handling Fee" v-positivePoint>
                <template slot="prefix">{{ currencySymbolFormat(billingCurrency) }}</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Bank Accounts" prop="bankAccountIds">
              <template v-if="dataForm.invoiceTemplateId">
                <select-bank-account v-model="dataForm.bankAccountIds" :supplierBankAccountList="invoiceTemplateBankAccountList" />
              </template>
              <div class="notSelectTipBg" v-else>Select invoice template first</div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Apply Reason" prop="applyReason">
              <el-input
                v-model="dataForm.applyReason"
                type="textarea"
                :rows="5"
                :autosize="{ minRows: 4 }"
                resize="none"
                placeholder="Apply Reason"
                v-regexFilter="halfWidthRegex"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">Cancel</el-button>
        <el-button type="primary" @click="dataFormSubmit">OK</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import SelectBankAccount from "@/components/SelectBankAccount";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    orderInfoList: {
      type: Array,
      default: () => [],
    },
    refundInfoList: {
      type: Array,
      default: () => [],
    },
    invoiceTemplateList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    SelectBankAccount,
  },
  data() {
    return {
      visible: false,
      idx: null,
      dataForm: {
        orderId: "",
        orderDescription: "",
        applyReason: "",
        deductionAcraFee: "",
        deductionHandlingFee: "",
        invoiceTemplateId: "",
        bankAccountIds: [],
      },
      dataRule: {
        orderId: [{ required: true, message: "please select", trigger: "submit" }],
        // applyReason: [{ required: true, message: "please enter", trigger: "submit" }],
        deductionAcraFee: [{ required: true, message: "please enter", trigger: "submit" }],
        deductionHandlingFee: [{ required: true, message: "please enter", trigger: "submit" }],
        invoiceTemplateId: [{ required: true, message: "please select", trigger: "submit" }],
        bankAccountIds: [{ type: "array", required: true, message: "please select", trigger: "submit" }],
      },
    };
  },
  computed: {
    // 已完成支付订单列表
    paidOrderInfoList() {
      const orderInfoList = this.orderInfoList || [];
      // 只保留订单状态为“已完成”的订单
      const list = orderInfoList.filter(item => item.status == "COMPLETE");
      return list;
    },
    // 已被使用的orderId数组
    usedOrderIdList() {
      const refundInfoList = this.refundInfoList || [];
      const list = refundInfoList.map(item => item.orderId);
      return list;
    },
    // 开票币种
    billingCurrency() {
      // 通过选中的发票id来匹配对应的银行账号列表
      const invoiceTemplateId = this.dataForm.invoiceTemplateId;
      const bankAccountList = this.invoiceTemplateList?.find(item => item.id == invoiceTemplateId)?.bankAccountList || [];
      // 选中的第一个银行的币种作为开票币种
      const firstBankAccountId = this.dataForm.bankAccountIds[0];
      const currency = bankAccountList.find(item => item.id == firstBankAccountId)?.billingCurrency;
      return currency || "";
    },
    // 银行账号列表
    invoiceTemplateBankAccountList() {
      // 通过选中的发票id来匹配对应的银行账号列表
      const invoiceTemplateId = this.dataForm.invoiceTemplateId;
      const bankAccountList = this.invoiceTemplateList?.find(item => item.id == invoiceTemplateId)?.bankAccountList;
      return bankAccountList || [];
    },
  },
  methods: {
    // 初始化
    async init(data, idx) {
      this.visible = true;
      await this.$nextTick();
      this.$refs["dataForm"].resetFields();
      if (data) {
        const dataCopy = JSON.parse(JSON.stringify(data));
        this.idx = idx;
        this.dataForm = {
          orderId: dataCopy.orderId,
          orderDescription: dataCopy.orderDescription,
          applyReason: dataCopy.applyReason,
          deductionAcraFee: dataCopy.deductionAcraFee,
          deductionHandlingFee: dataCopy.deductionHandlingFee,
          invoiceTemplateId: dataCopy.invoiceTemplateId,
          bankAccountIds: dataCopy.bankAccountIds || [],
        };
      } else {
        this.idx = null;
      }
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          const dataForm = JSON.parse(JSON.stringify(this.dataForm));
          this.$emit("refreshDataList", dataForm, this.idx);
          this.visible = false;
        }
      });
    },
    // Refund Order下拉框 - change
    orderIdChange() {
      const orderId = this.dataForm.orderId;
      if (orderId) {
        const description = this.paidOrderInfoList.find(item => item.id == orderId)?.description || "";
        this.dataForm.orderDescription = description;
      } else {
        this.dataForm.orderDescription = "";
      }
    },
    // Invoice Template - Change
    invoiceTemplateChange() {
      this.$set(this.dataForm, "bankAccountIds", []);
    },
  },
};
</script>

<style lang="scss" scoped>
.notSelectTipBg {
  padding: 6px 10px;
  background: #f5f7fa;
  border-radius: 2px;
}
</style>
